const ROOT_CSS_CLASS = 'spa-pagination';
const DEFAULTS = {
  pagination: {
    id: null,
    domContainer: null,
    callback: null,
    align: 'right',
    style: 'none',
    // none | basic | advanced | progressive
    size: 25,
    sizeList: [10, 25, 50, 100],
    index: 0,
    length: 0,
    totalRecords: 0,
    title: null,
    allowPageSizeChange: true,
    setDefaultProgressiveFocus: false,
    jcrData: {
      display: 'Rows',
      first: 'First',
      for: 'for',
      last: 'Last',
      next: 'Next',
      noMoreDataPrefix: 'After this data set, there will be',
      noMoreDataToLoad: 'Nothing more to show',
      noMoreDataSuffix: '',
      of: 'of',
      pageType: 'Page',
      rowsPerPage: 'Rows per page',
      perPage: 'per page',
      previous: 'Previous',
      results: 'results',
      selectNumberOfResults: 'Select the number of results per page that you would like displayed',
      selectPageNumber: 'Select the page number that you would like displayed',
      showMoreRows: 'Show more',
      showing: 'Showing',
      showingNext: 'Showing next',
      to: 'to'
    }
  }
};
const paginationEventsClassList = [`${ROOT_CSS_CLASS}-btn--previous`, `${ROOT_CSS_CLASS}-btn--next`, `${ROOT_CSS_CLASS}-btn--first`, `${ROOT_CSS_CLASS}-btn--last`, `${ROOT_CSS_CLASS}-btn--page-size`, `${ROOT_CSS_CLASS}-btn--page-list`, `${ROOT_CSS_CLASS}-btn--load-more`];

/**
 * Class used to register helper with Handlebars.
 */
class PaginationDefaultsUtility {
  /**
   * Provides Pagination Default Options
   * @returns {object} Pagination defaults
   */
  static getPaginationDefaults() {
    return DEFAULTS.pagination;
  }

  /**
   * Provides Pagination Events Class List
   * @returns {object} Pagination Events List
   */
  static getPaginationEventList() {
    return paginationEventsClassList;
  }
}

export { PaginationDefaultsUtility as default };
